import { HEADERS, STATUSES } from './options'

export const getTypeByAccessibility = ({
  hasAvailability,
  mission,
  isActive,
  isTimeOff,
  isExpiredContract,
}) => {
  if (isExpiredContract) {
    if (mission) {
      if (mission.isNotShown) {
        return {
          type: STATUSES.MISSION_BOOKED_WITH_EXPIRED_CONTRACT,
          background: `linear-gradient(to bottom right, #FFDDBE 0%, #FFDDBE 33%, #F2F2F2 33%, #F2F2F2 66%, #004360 66%, #004360 100%)`,
          hint:
            'This BA, booked for this mission, does not have a contract for this time period. Mission not shown. This may indicate a scheduling conflict or override.',
          onClick: () =>
            window.open(`/dashboard/mission/${mission.id}`, '_blank'),
        }
      } else {
        return {
          type: STATUSES.MISSION_BOOKED_WITH_EXPIRED_CONTRACT,
          background: `linear-gradient(to bottom right, #F2F2F2 0%, #F2F2F2 50%, #004360 50%, #004360 100%)`,
          hint:
            'This BA, booked for this mission, does not have a contract for this time period. This may indicate a scheduling conflict or override.',
          onClick: () =>
            window.open(`/dashboard/mission/${mission.id}`, '_blank'),
        }
      }
    } else {
      return {
        background: '#F2F2F2',
        type: STATUSES.IS_EXPIRED_CONTRACT,
        hint: 'This BA does not have a contract for this time period.',
      }
    }
  }

  if (isTimeOff) {
    if (mission) {
      if (mission.isNotShown) {
        return {
          type: STATUSES.MISSION_BOOKED_ON_TIME_OFF,
          background: `linear-gradient(to bottom right, #FFDDBE 0%, #FFDDBE 33%, #FDFAAC 33%, #FDFAAC 66%, #004360 66%, #004360 100%)`,
          hint:
            'This BA was booked for this mission despite being marked time off for this time slot. Mission not shown. This may indicate a scheduling conflict or override.',
          onClick: () =>
            window.open(`/dashboard/mission/${mission.id}`, '_blank'),
        }
      } else {
        return {
          type: STATUSES.MISSION_BOOKED_ON_TIME_OFF,
          background: `linear-gradient(to bottom right, #FDFAAC 0%, #FDFAAC 50%, #004360 50%, #004360 100%)`,
          hint:
            'This BA was booked for this mission despite being marked time off for this time slot. This may indicate a scheduling conflict or override.',
          onClick: () =>
            window.open(`/dashboard/mission/${mission.id}`, '_blank'),
        }
      }
    } else {
      return {
        background: '#FDFAAC',
        type: STATUSES.TIME_OFF,
        hint: 'Time Off',
      }
    }
  }

  if (hasAvailability) {
    if (mission) {
      if (isActive) {
        if (mission.isNotShown) {
          return {
            background: `#FFDDBE`,
            type: STATUSES.MISSION_NOT_SHOWN,
            hint:
              'This BA did not show up for a mission during this time slot. Click to view the mission details.',
            onClick: () =>
              window.open(`/dashboard/mission/${mission.id}`, '_blank'),
          }
        } else {
          return {
            background: '#D5D5FC',
            type: STATUSES.MISSION_BOOKED_IN_ACTIVE_SLOT,
            hint:
              'This BA is already booked for another mission during this time slot. Click to view mission details.',
            onClick: () =>
              window.open(`/dashboard/mission/${mission.id}`, '_blank'),
          }
        }
      } else {
        if (mission.isNotShown) {
          return {
            type: STATUSES.MISSION_BOOKED_IN_NOT_ACTIVE_SLOT,
            background: `linear-gradient(to bottom right, #FFDDBE 0%, #FFDDBE 33%, #D5D5FC 33%, #D5D5FC 66%, #004360 66%, #004360 100%)`,
            hint:
              'This BA was booked for this mission despite being marked unavailable for this time slot. Mission not shown. This may indicate a scheduling conflict or override.',
            onClick: () =>
              window.open(`/dashboard/mission/${mission.id}`, '_blank'),
          }
        } else {
          return {
            type: STATUSES.MISSION_BOOKED_IN_NOT_ACTIVE_SLOT,
            background: `linear-gradient(to bottom right, #D5D5FC 0%, #D5D5FC 50%, #004360 50%, #004360 100%)`,
            hint:
              'This BA was booked for this mission despite being marked unavailable for this time slot. This may indicate a scheduling conflict or override.',
            onClick: () =>
              window.open(`/dashboard/mission/${mission.id}`, '_blank'),
          }
        }
      }
    } else {
      if (isActive) {
        return {
          type: STATUSES.AVAILABLE_SLOT,
          background: '#A0E19E',
          hint: 'This BA is available to work during this time slot.',
        }
      } else {
        return {
          type: STATUSES.NOT_AVAILABLE_SLOT,
          background: '#FBD2D9',
          hint: 'This BA is not available to work during this time slot.',
        }
      }
    }
  } else {
    if (mission) {
      if (mission.isNotShown) {
        return {
          type: STATUSES.MISSION_BOOKED_WITHOUT_AVAILABILITY,
          background: `linear-gradient(to bottom right, #FFDDBE 0%, #FFDDBE 33%, #F2F2F2 33%, #F2F2F2 66%, #004360 66%, #004360 100%)`,
          hint:
            'This BA was booked for this mission despite being marked unavailable for this time slot. Mission not shown. This may indicate a scheduling conflict or override.',
          onClick: () =>
            window.open(`/dashboard/mission/${mission.id}`, '_blank'),
        }
      } else {
        return {
          type: STATUSES.MISSION_BOOKED_WITHOUT_AVAILABILITY,
          background: `linear-gradient(to bottom right, #F2F2F2 0%, #F2F2F2 50%, #004360 50%, #004360 100%)`,
          hint:
            'This BA was booked for this mission despite being marked unavailable for this time slot. This may indicate a scheduling conflict or override.',
          onClick: () =>
            window.open(`/dashboard/mission/${mission.id}`, '_blank'),
        }
      }
    } else {
      return {
        type: STATUSES.DONT_HAVE_AVAILABILITY,
        background: '#F2F2F2',
        hint:
          "This BA is unavailable for this time slot. This could be because it's a Saturday morning or they haven't set their availability for the week yet.",
      }
    }
  }
}

export const convertTypeToLabel = type => {
  if (!type) return type
  return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
}

export const getHeaders = ({ showDistance, bookBa }) => {
  const headers = [...HEADERS]
  if (showDistance) {
    headers.push({
      id: 'distance',
      name: 'Distance',
      align: 'center',
      sort: true,
    })
  }
  if (bookBa) {
    headers.push({ id: 'ba', name: 'Actions', align: 'center', sort: false })
  }

  return headers
}

export const getColSpan = ({ bookBa, showDistance }) => {
  let colSpan = 8
  if (bookBa) {
    colSpan += 1
  }
  if (showDistance) {
    colSpan += 1
  }
  return colSpan
}

export const descendingComparator = (a, b, orderBy) => {
  const sorterA = a[orderBy] ? a[orderBy] : a.accessibilityWithMissions[orderBy]
  const sorterB = b[orderBy] ? b[orderBy] : b.accessibilityWithMissions[orderBy]

  if (sorterB < sorterA) {
    return -1
  }
  if (sorterB > sorterA) {
    return 1
  }
  return 0
}

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) {
      return order
    }
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}
